import { CamionNetBaseApiClient } from '../base-client';

/**
 * Plates API Types
 */
export interface UploadPlateRequest {
  image: File;
}

export interface UploadPlateResponse {
  url: string;
  immatriculation?: string;
}

/**
 * Plates API Endpoints
 */
export class PlatesApi extends CamionNetBaseApiClient {
  /**
   * Upload a plate image
   */
  async uploadPlate(data: UploadPlateRequest): Promise<UploadPlateResponse> {
    const formData = new FormData();
    formData.append('image', data.image);

    return this.request<UploadPlateResponse>('/api2/plates/upload', {
      method: 'POST',
      headers: { version: this.version }, // No Content-Type for FormData
      body: formData,
    });
  }
}
